import * as React from 'react';

import { ChevronLeftIcon, ChevronRightIcon } from '@notino/react-styleguide';

import { IImageProperties } from '@helpers/utils';
import { useArrows } from '@hooks/useArrows';
import { Fade, Arrow } from '@hooks/useArrows/styled';

import { useProductDetailContext } from '../../ProductDetailContext';

import { Image } from './Image';
import { ImageWrapper, ScrollWrapper, Wrapper } from './ScrollThumbs.styles';

interface IProps {
  imageIndex: number;
  handleImageChange: (index: number) => void;
  handleImageClick?: (index: number) => React.MouseEventHandler<HTMLElement>;
  imagesAttrs: IImageProperties[];
  cypressDataValue?: string;
}

export const ScrollThumbs = ({
  imageIndex,
  handleImageChange,
  handleImageClick,
  imagesAttrs,
  cypressDataValue,
}: IProps) => {
  const { currentVariant } = useProductDetailContext();
  const { containerRef, scrollTo, showLeftArrow, showRightArrow } = useArrows([
    currentVariant.webId,
  ]);

  return (
    <Wrapper data-cypress={cypressDataValue}>
      {showLeftArrow && (
        <>
          <Arrow position="left" onClick={() => scrollTo('left')} role="button">
            <ChevronLeftIcon
              color="icon.primary"
              height="1.25rem"
              width="1.25rem"
            />
          </Arrow>
          <Fade position="left" />
        </>
      )}

      <ScrollWrapper ref={containerRef}>
        {imagesAttrs.map((imageAttr, index) => (
          <ImageWrapper key={imageAttr.src}>
            <Image
              {...imageAttr}
              isSelected={index === imageIndex}
              onClick={handleImageClick?.(index)}
              onMouseOver={() => handleImageChange(index)}
            />
          </ImageWrapper>
        ))}
      </ScrollWrapper>

      {showRightArrow && (
        <>
          <Arrow
            position="right"
            onClick={() => scrollTo('right')}
            role="button"
          >
            <ChevronRightIcon
              color="icon.primary"
              height="1.25rem"
              width="1.25rem"
            />
          </Arrow>
          <Fade position="right" />
        </>
      )}
    </Wrapper>
  );
};
